import {Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[ao-stop-propagation]'
})
export class AOStopPropagationDirective {

  constructor() {
  }

  @HostListener('click', ['$event']) click($event) {
    $event.stopPropagation();
  }

}
